/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    status?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    details?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails;
    /**
     * 
     * @type {number}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    created_at?: string;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    status_set_by_user?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    receipt_id?: string;
    /**
     * 
     * @type {Array<HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner>}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    updates?: Array<HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSON(json['details']),
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'status_set_by_user': !exists(json, 'status_set_by_user') ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON(json['status_set_by_user']),
        'receipt_id': !exists(json, 'receipt_id') ? undefined : json['receipt_id'],
        'updates': !exists(json, 'updates') ? undefined : ((json['updates'] as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSON)),
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistToJSON(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': value.status,
        'details': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSON(value.details),
        'rank': value.rank,
        'created_at': value.created_at,
        'status_set_by_user': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON(value.status_set_by_user),
        'receipt_id': value.receipt_id,
        'updates': value.updates === undefined ? undefined : ((value.updates as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSON)),
    };
}

